import { configureStore } from '@reduxjs/toolkit';
import project from './project/projectSlice';
import result from './result/resultSlice';
import alert from './alert/alertSlice';
import user from './user/userSlice';
import engine from './engine/engineSlice';
import map from './map/mapSlice';

export const redux = configureStore({
    reducer: {
        user,
        project,
        result,
        alert,
        engine,
        map
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof redux.getState>;
export type AppDispatch = typeof redux.dispatch;
